import { render, staticRenderFns } from "./TablaOfertas.vue?vue&type=template&id=7368c9cc"
import script from "./TablaOfertas.vue?vue&type=script&lang=js"
export * from "./TablaOfertas.vue?vue&type=script&lang=js"
import style0 from "./TablaOfertas.vue?vue&type=style&index=0&id=7368c9cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports